<div *ngIf="visible" class="atos-bandeau-info-banner" id="atos-bandeau-info-banner">
    <p>Attention NE PAS TESTER TAXI et TAD à partir du Mardi 25/06 14h jusqu'au Vendredi 28 juin (Ils sont sur la production durant cette période) </p>
    <button class="close-banner" (click)="visible = false">X</button>
</div>